import uh1 from "./uh-1.jpg";
import uh2 from "./uh-2.jpg";
import uh3 from "./uh-3.jpg";
import uh4 from "./uh-4.jpg";
import uh5 from "./uh-5.jpg";
import uh6 from "./uh-6.jpg";
import uh7 from "./uh-7.jpg";
import uh8 from "./uh-8.jpg";
import uh9 from "./uh-9.jpg";
import uh10 from "./uh-10.jpg";
import uh11 from "./uh-11.jpg";
import uh12 from "./uh-12.jpg";
import uh13 from "./uh-13.jpg";
import uh14 from "./uh-14.jpg";
import uh15 from "./uh-15.jpg";
import uh16 from "./uh-16.jpg";
import uh17 from "./uh-17.jpg";
import uh18 from "./uh-18.jpg";
import uh19 from "./uh-19.jpg";
import uh20 from "./uh-20.jpg";
import uh21 from "./uh-21.jpg";
import uh22 from "./uh-22.jpg";
import uh23 from "./uh-23.jpg";
import uh24 from "./uh-24.jpg";
import uh25 from "./uh-25.jpg";
import uh26 from "./uh-26.jpg";
import uh27 from "./uh-27.jpg";
import uh28 from "./uh-28.jpg";
import uh29 from "./uh-29.jpg";
import uh30 from "./uh-30.jpg";
import uh31 from "./uh-31.jpg";
import uh32 from "./uh-32.jpg";
import uh33 from "./uh-33.jpg";
import uh34 from "./uh-34.jpg";
import uh35 from "./uh-35.jpg";
import uh36 from "./uh-36.jpg";
import uh37 from "./uh-37.jpg";
import uh38 from "./uh-38.jpg";
import uh39 from "./uh-39.jpg";
import uh40 from "./uh-40.jpg";
import uh41 from "./uh-41.jpg";
import uh42 from "./uh-42.jpg";
import uh43 from "./uh-43.jpg";
import uh44 from "./uh-44.jpg";
import uh45 from "./uh-45.jpg";
import uh46 from "./uh-46.jpg";
import uh47 from "./uh-47.jpg";
import uh48 from "./uh-48.jpg";
import uh49 from "./uh-49.jpg";
import uh50 from "./uh-50.jpg";
import uh51 from "./uh-51.jpg";
import uh52 from "./uh-52.jpg";
import uh53 from "./uh-53.jpg";
import uh54 from "./uh-54.jpg";
import uh55 from "./uh-55.jpg";
import uh56 from "./uh-56.jpg";
import uhFp1np3d from "./uh-fp-1np-3d.jpg";
import uhFp1np2d from "./uh-fp-1np-2d.jpg";
import uhFp2np3d from "./uh-fp-2np-3d.jpg";
import uhFp2np2d from "./uh-fp-2np-2d.jpg";
import uhFpPp3d from "./uh-fp-pp-3d.jpg";
import uhFpPp2d from "./uh-fp-pp-2d.jpg";

export const uhoniceImages = [
  uh1, uh2, uh3, uh4, uh6, uh7, uh8, uh9, uh10,
  uh11, uh12, uh13, uh14, uh15, uh16, uh17, uh18, uh19, uh20,
  uh21, uh22, uh23, uh24, uh25, uh26, uh27, uh28, uh29, uh30,
  uh31, uh32, uh33, uh34, uh35, uh36, uh37, uh38, uh39, uh40,
  uh41, uh42, uh43, uh44, uh45, uh46, uh47, uh48, uh49, uh50,
  uh51, uh52, uh53, uh54, uh55, uh56,
];

export const uhoniceFloorPlans = [
  { image: uhFp1np3d, label: "1. NP – 3D" },
  { image: uhFp1np2d, label: "1. NP – 2D" },
  { image: uhFp2np3d, label: "2. NP – 3D" },
  { image: uhFp2np2d, label: "2. NP – 2D" },
  { image: uhFpPp3d, label: "PP – 3D" },
  { image: uhFpPp2d, label: "PP – 2D" },
];
